<template>
  <section>
    <el-table
      class="el-table-info"
      :data="tabledata"
      stripe
      style="width: 100%;margin-top: 30px"
      :show-overflow-tooltip="true"
      border
    >
      <el-table-column
        :formatter="publicFmt"
        prop="supplierName"
        label="供应商名称"
      >
      </el-table-column>
      <el-table-column
        :formatter="publicFmt"
        prop="sysSupplierFullName"
        label="开票公司"
      >
      </el-table-column>
      <el-table-column
        prop="ticketPayment"
        :formatter="NumFmt"
        label="进票金额"
      >
      </el-table-column>
      <el-table-column
        :formatter="publicFmt"
        prop="invoiceNumber"
        label="发票号"
      >
      </el-table-column>
      <el-table-column
        :formatter="contractCompanyFmt  "
        prop="invoiceCompany"
        label="合同公司"
      >
      </el-table-column>
      <el-table-column
        prop="createDate"
        :formatter="(row, column, cellValue, index) => { return myFmtDateTime(cellValue,'MM/DD')}"
        label="暂存时间"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        width="300"
      >
        <template slot-scope="scope">
          <el-button @click="showDetail(scope.row)" type="text" size="small">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      class="xuanxiang"
      title="进票数据"
      :visible.sync="showApplyTicket"
      width="60%"
      :before-close="ApplyhandleClose"
      :close-on-click-modal=false
      :append-to-body="true"
    >
      <el-table
        :data="tabledata111"
        class="el-table-info"
        :summary-method="getSummaries"
        show-summary
        stripe
        style="margin-left: 5%;width: 90%;"
      >
        <el-table-column
          :formatter="publicFmt"
          prop="shipName"
          label="船舶名称"
          width="80">
        </el-table-column>
        <el-table-column
          :formatter="costTypeFmt"
          prop="costTypeName"
          label="费用类型"
          width="80">
        </el-table-column>
        <el-table-column
          :formatter="contractCompanyFmt"
          prop="contractCompanyName"
          label="收票公司"
          width="100">
        </el-table-column>
        <el-table-column
          :formatter="costProjecttax"
          prop="billTax"
          label="税率"
          width="90">
        </el-table-column>
        <el-table-column
          :formatter="NumFmt"
          prop="settleTonnage"
          label="吨位"
          width="90">
        </el-table-column>
        <el-table-column
          :formatter="NumFmt"
          prop="priceWithTax"
          :label="labelName"
          width="90">
        </el-table-column>
        <el-table-column
          :formatter="NumFmt"
          prop="leftOver"
          label="总剩余"
          width="120"
        >
        </el-table-column>
        <el-table-column
          :formatter="NumFmt"
          prop="currentAmount"
          label="本次进票金额"
        >
        </el-table-column>
      </el-table>
    </el-dialog>
  </section>
</template>

<script>
    import {fmtDictionary} from "../../jslib/util";
    import dayjs from "dayjs";
    import {getDictionaryList} from "../../api/sysdictionary";
    import {ERR_OK} from "../../jslib/config";
    import {getBatchTicketApprove, getPayment} from "../../api/PaymentApply";

    export default {
        name: "TicketBatchApprove",
      props: {
        datas: {
          type: Object
        },
        applyList:{
          type: Array
        },
      },
      data(){
        return{
          tabledata:[],
          multipleSelection:[],
          dictionaryLists:[],
          contractCompanyList:[],
          tabledata111:[],
          newdictionaryLists:[],
          isGoods:false,
          labelName:null,
          showApplyTicket:false,
          pageTitle:null,
        }
      },
      mounted() {
        this.getData()
        getDictionaryList("cost_type,contract_company,bill_tax,items_occurred,other_expenditure").then(res=>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            this.dictionaryLists = res.map
            for(var i=0;i<this.dictionaryLists["contract_company"].length;i++){
              if(this.dictionaryLists["contract_company"][i].code == 10 || this.dictionaryLists["contract_company"][i].code == 20){
                this.contractCompanyList.push(this.dictionaryLists["contract_company"][i])
              }
            }
          }
        })
      },
        methods: {
          ApplyhandleClose(){
            this.showApplyTicket = false
          },
          showDetail(obj){
            if(obj.routeName == "applyinterticketshippay"){
              this.isGoods = false
              this.labelName = "单价"
              this.pageTitle = "船舶运费"
            } else if (obj.routeName == "applyinterticketgoods") {
              this.isGoods = true
              this.labelName = "单价"
              this.pageTitle = "货物费用"
            } else if(obj.routeName == "applyinterticketshipcost") {
              this.isGoods = false
              this.labelName = "金额"
              this.pageTitle = "船上费用"
            } else if(obj.routeName == "applyinterticketothercost"){
              this.isGoods = false
              this.labelName = "金额"
              this.pageTitle = "其他费用"
            }
            this.contractCompanyList = []
            if(this.isGoods){
              this.newdictionaryLists = this.dictionaryLists["cost_type"]
            } else {
              if(obj.routeName == "applyinterticketothercost"){
                this.newdictionaryLists = this.dictionaryLists["other_expenditure"]
              } else {
                this.newdictionaryLists = this.dictionaryLists["items_occurred"]
              }
            }
            this.tabledata111 = obj.paymentCostList
            this.showApplyTicket = true
          },
          getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
              if (index === 0) {
                sums[index] = '总计';
                return;
              }
              if(index < 4 || column.label == "单价"){
                sums[index] = '--';
                return;
              }
              const values = data.map(item =>Math.abs(Number(item[column.property])) );
              if (!values.every(value => isNaN(value))) {
                sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);
                sums[index] = this.NumFmt(null,null,sums[index],null);
                // sums[index] += ' 元';
              } else {
                sums[index] = '--';
              }
            });
            return sums;
          },
          getData(){
            if(this.applyList){
              this.tabledata = this.applyList
            } else {
              var querydata = {
                applyIds:this.datas.params1,
              }
              getBatchTicketApprove(querydata).then(res=>{
                if (res!=undefined&&res.resultCode === ERR_OK) {
                  this.tabledata = res.list
                }
              })
            }
          },
          publicFmt(row,column,cellValue,index){
            var v = '--'
            if(cellValue!=undefined&&cellValue!=null&&cellValue!=''){
              v = cellValue
            }
            return v
          },
          NumFmt(row,column,cellValue,index){
            var v = 0
            if(cellValue!=undefined&&cellValue!=null&&cellValue!=''){
              v = parseFloat(Math.abs(cellValue).toFixed(2))
            }
            return v
          },
          contractCompanyFmt(row,column,cellValue,index){
            return fmtDictionary(cellValue,this.contractCompanyList);
          },
          myFmtDateTime(cellValue,fmtstr){
            if(cellValue==undefined||cellValue==null||cellValue==''){
              return '--'
            }
            return dayjs(cellValue).format(fmtstr)
          },
          costTypeFmt(row,column,cellValue,index){
            return fmtDictionary(cellValue,this.newdictionaryLists);
          },
          costProjecttax(row, column, cellValue, index) {
            return fmtDictionary(cellValue, this.dictionaryLists['bill_tax']);
          },
        }
    }
</script>

<style scoped>
  .query-form{
    text-align: left;
    padding-top: 10px;
  }
  .sp_add_left{
    width: 45%;
    margin-right: 5%;
  }
  .sp_add_right{
    width: 45%;
  }
  .el-table-info >>> .cell{
    text-align: center;
  }
  .el-table-info >>> th {
    background: #EDF5FF;
  }
</style>
